<template>
    <div>
        <div class="eprescribe--item">
            <common-content-spacer v-if="eprescribe.referralType === ReferralTypeEnum.DIRECT" height="small">
                <common-user-avatar
                    class="eprescribe--item__avatar"
                    size="member-switch"
                    :user="eprescribe.selectedUser"
                    :isUserProfileLinkEnabled="false"
                ></common-user-avatar>
                <common-user-name class="eprescribe--item__header" :user="eprescribe.selectedUser"></common-user-name>

                <div v-if="eprescribe.practiceType === PracticeTypeEnum.PHYSICIAN">
                    <common-content-spacer height="small">
                        <p>{{ eprescribe.selectedUser?.practice?.name }}</p>
                        <common-rating-stars :rating="eprescribe.selectedUser.rating"></common-rating-stars>
                        <common-specialities :specialities="eprescribe.selectedUser.specialities"></common-specialities>
                    </common-content-spacer>
                </div>
                <div v-if="eprescribe.practiceType === PracticeTypeEnum.ANCILLARY">
                    <common-badges-list
                        v-if="eprescribe.testsList.length"
                        :listElements="eprescribe.testsList.map((item) => item.name)"
                    ></common-badges-list>
                </div>
            </common-content-spacer>
            <common-content-spacer v-if="eprescribe.referralType === ReferralTypeEnum.MATCH" height="small">
                <users-overview
                    :members="eprescribe.matched.slice(0, 3)"
                    :memberCount="eprescribe.matched.length"
                    :pendingMembersCount="0"
                    :isUserProfileLinkEnabled="false"
                    @users-count-clicked="toggleMatchModal"
                ></users-overview>
                <p class="eprescribe--item__text--info">
                    {{ $t('pages.eprescribe.eprescribe.eprescribe_insurance') }}
                    <b>{{ getInsuranceLabel }}</b>
                </p>
                <p v-if="eprescribe.practiceType === PracticeTypeEnum.PHYSICIAN" class="eprescribe--item__text--info">
                    {{ $t('pages.eprescribe.eprescribe.eprescribe_speciality') }}
                    <b>{{ getSpecialityLabel }}</b>
                </p>
                <p v-if="eprescribe.practiceType === PracticeTypeEnum.PHYSICIAN" class="eprescribe--item__text--info">
                    {{ $t('pages.eprescribe.eprescribe.eprescribe_subspeciality') }}
                    <b>{{ getSubSpecialityLabel }}</b>
                </p>
                <p class="eprescribe--item__text--info">
                    {{ $t('pages.eprescribe.eprescribe.eprescribe_zip') }}
                    <b>{{ eprescribe.zip }}</b>
                </p>
                <common-badges-list
                    v-if="eprescribe.selectedTests.length"
                    :listElements="eprescribe.selectedTests.map((item) => item.name)"
                ></common-badges-list>
            </common-content-spacer>
            <div v-if="showDeleteIcon" class="eprescribe--item__delete">
                <common-icon name="trash-bin" size="medium" @click="removeItem()"></common-icon>
            </div>
        </div>
        <eprescribe-macthed-modal
            v-if="isEprescribeMatchModalOpen"
            :matchList="eprescribe.matched"
            :practiceType="eprescribe.practiceType"
            @close="isEprescribeMatchModalOpen = false"
        ></eprescribe-macthed-modal>
    </div>
</template>

<script>
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'
    import UsersOverview from 'components/page-elements/practice/UsersOverview'
    import EprescribeMacthedModal from 'components/ePrescribe/EprescribeMacthedModal'
    import ReferralTypeEnum from '@/enums/ReferralTypeEnum'

    export default {
        components: { UsersOverview, EprescribeMacthedModal },
        props: {
            eprescribe: { type: Object, required: true },
            index: { type: Number, default: null },
            showDeleteIcon: { type: Boolean, default: true },
            insurancePlans: { type: Array, required: true },
            specialities: { type: Array, required: true },
            facilityServices: { type: Array, required: true },
            states: { type: Array, required: true },
        },
        data() {
            return {
                PracticeTypeEnum: PracticeTypeEnum,
                ReferralTypeEnum: ReferralTypeEnum,
                isEprescribeMatchModalOpen: false,
            }
        },

        computed: {
            getInsuranceLabel() {
                return this.insurancePlans.find((item) => item.value === this.eprescribe.insurancePlanId).label
            },

            getSpecialityLabel() {
                return this.specialities.find((item) => item.value === this.eprescribe.specialityId).label
            },

            getSubSpecialityLabel() {
                return this.specialities
                    .find((item) => item.value === this.eprescribe.specialityId)
                    .data.subSpecialities.find((el) => el.id === this.eprescribe.subSpecialityId).name
            },
        },

        methods: {
            avatarPosition(index) {
                if (this.eprescribe.matched.length > 1) {
                    if (index === 0) {
                        return 'users-overview__avatar-left'
                    } else if (index === 1) {
                        return 'users-overview__avatar-middle'
                    } else if (index === 2) {
                        return 'users-overview__avatar-right'
                    }
                }
            },

            toggleMatchModal() {
                this.isEprescribeMatchModalOpen = !this.isEprescribeMatchModalOpen
            },

            removeItem() {
                this.$emit('remove-item', this.index)
            },
        },
    }
</script>

<style lang="scss">
    @import 'styles/components/referrals/_eprescribe-item-preview';
</style>
